module.exports = __webpack_public_path__ + "static/media/btn_qx.1c17a307.png";